export default "__VITE_ASSET__DEsQJ8Sv__"